import Hero from './components/Hero';
import About from './components/About';
import InvestmentFocus from './components/InvestmentFocus';
import Portfolio from './components/Portfolio';
import Partnership from './components/Partnership';
import InvestorOpportunities from './components/InvestorOpportunities';
import Contact from './components/Contact';

export default function HomePage() {
  return (
    <div className="bg-black min-h-screen">
      <Hero />
      <About />
      <InvestmentFocus />
      <Portfolio />
      <Partnership />
      <InvestorOpportunities />
      <Contact />
    </div>
  );
}
